import { createSlice } from '@reduxjs/toolkit'
import { fetchGeneralReport } from 'redux-thunk/thunk/reports/generalReports.thunk'

const initialState = {
  generalReport: null
}

const generalReportSlice = createSlice({
  name: 'generalReportSlice',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchGeneralReport.fulfilled, (state, action) => {
        return {
          ...state,
          generalReport: action.payload
        }
      })
  }
})

export default generalReportSlice.reducer
